module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-select-item",
    attrs: {
      "data-isitem": "true"
    },
    on: {
      "click": _vm.select
    }
  }, [_vm._v(_vm._s(_vm.$props.label))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9f704312","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZSelectItem.vue
// module id = 1228
// module chunks = 0